import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { adminRoleMyConfig } from './request';
import { mergeCells } from '../../customer/roleManage/utils';
const staticColumns = [{
  slots: {
    title: '部门'
  },
  dataIndex: 'structureName',
  key: 'structureName',
  align: 'center',
  customRender: (text, row, index) => {
    if (!text) {
      return '—';
    }
    return text;
  }
}, {
  slots: {
    title: '应用'
  },
  dataIndex: 'appName',
  key: 'appName',
  align: 'center',
  customRender: (text, row, index) => {
    console.log(row.authorityTypeValue);
    if (!text) {
      return '—';
    }
    return text;
  }
}, {
  slots: {
    title: '中介'
  },
  dataIndex: 'agencyName',
  key: 'agencyName',
  align: 'center',
  customRender: (text, row, index) => {
    if (!text) {
      return '—';
    }
    return text;
  }
}, {
  slots: {
    title: '客户'
  },
  dataIndex: 'customerName',
  key: 'customerName',
  align: 'center',
  customRender: (text, row, index) => {
    if (!text) {
      return '—';
    }
    return text;
  }
}];
const rolePermissionsTypeObj = {
  1: '个人',
  2: '全部',
  3: '指定部门',
  4: '所属部门'
};
export default {
  name: 'admin-data-authority',
  data() {
    return {
      columns: [{
        slots: {
          title: '菜单'
        },
        dataIndex: 'menuName',
        align: 'center',
        key: 'menuName',
        customRender: (text, row, index) => {
          const obj = {
            children: this.$t(text),
            attrs: {
              rowSpan: row.menuNameRowSpan
            }
          };
          return obj;
        }
      }, {
        slots: {
          title: '数据权限'
        },
        dataIndex: 'rolePermissionsType',
        key: 'rolePermissionsType',
        align: 'center',
        // width: '50%',
        // scopedSlots: {customRender: 'dataAuthority'},
        customRender: (text, row, index) => {
          return {
            children: text ? this.$t(rolePermissionsTypeObj[text]) : '—',
            attrs: {
              rowSpan: row.menuNameRowSpan
            }
          };
        }
      }],
      tableData: []
    };
  },
  created() {
    this.initAuthorityList();
  },
  methods: {
    async initAuthorityList() {
      console.log(this.$route.params);
      const res = await adminRoleMyConfig({
        roleId: this.$route.params.id
      });
      this.columns = this.columns.concat(staticColumns);
      this.tableData = mergeCells(res, 'menuName').map(item => {
        item.authorityTypeValue = 1;
        return item;
      });
    }
  }
};